import {IUser,User} from 'src/app/core/user/user.model';
import {BankInfo,IBankInfo} from 'src/app/shared/model/bank-info.model';
import {ContactDetailDTO,IContactDetailDTO} from 'src/app/shared/model/contact-details-dto.model';
import {IInternalStaff} from 'src/app/shared/model/internal-staff.model';
import {AddressMySuffix,IAddressMySuffix} from './address-my-suffix.model';
import {BrokerDTO} from './broker.model';



export const enum ActiveStatus {
    ACTIVE = 'ACTIVE',
    IN_ACTIVE = 'IN_ACTIVE'
}
export const enum TypeOfEntity {
    INDIVIDUAL = 'INDIVIDUAL',
    COMPANY = 'COMPANY'
}

export const enum TypeOfClient {
    FREIGHT_FORWARDER = 'FREIGHT_FORWARDER',
    TRADER = 'TRADER'
}

export const enum Accessibility {
    FULL_ACCESS = 'FULL_ACCESS',
    PROVISIONAL_ACCESS = 'PROVISIONAL_ACCESS'
}

export interface IClientDTO {
    id?: number;
    activeStatus?: ActiveStatus;
    companyName?: string;
    typeOfClient?: TypeOfClient;
    userDTO?: IUser;
    user?: IUser;
    bankDetails?: IBankInfo[];
    contactDetails?: IContactDetailDTO[];
    clientStaffs?: IInternalStaff[];
    managerDTO?: IUser;
    lastModifiedBy?: string;
    createdByUserRole?: string;
    lastModifiedByUserRole?: string;
    automaticQuotation?: boolean;
    fromEffectiveDate?: string;
    accessibility?: any;
    reasonForApproval?: string;
    captcha?: any
    oneTimePassword?: string
    policyEditPermission?: boolean
    isAccessPlatform?: boolean;
    //  quickLinksPermissionDTOS?: IQuickLinksPermissionDto;
    isAllowedAccouting?: boolean
    enableSanctionScreening?: boolean
    finscanResultStatus?: string
    isAllowedForBulkDeclaration?: boolean;
    entityType?: TypeOfEntity;
    website?: string;
    policyHolderId?: string;
    addressDTO?: IAddressMySuffix; // used in update
    referredByBroker?: BrokerDTO;
    referredByUnderwriter?: BrokerDTO;
    referredByInsurer?: BrokerDTO;
    address?: IAddressMySuffix; // used in view
    policyCurrency?: string;
    policyCurrencyValue?: number;
    finScanResultData?: string;
    isCoAssured?: boolean;
    coAssuredInceptionDate?: string;
    coAssuredExpiryDate?: string;
    enablePoliticalRisk?: boolean;
}

export class ClientDTO implements IClientDTO {
    constructor(
        public id?: number,
        public activeStatus?: ActiveStatus,
        public userDTO = new User(),
        public user = new User(),
        public typeOfClient: TypeOfClient = null,
        public bankDetails: IBankInfo[] = [],
        public companyName?: string,
        public contactDetails: ContactDetailDTO[] = [],
        public clientStaffs?: IInternalStaff[],
        public managerDTO?: IUser,
        public lastModifiedBy?: string,
        public createdByUserRole?: string,
        public lastModifiedByUserRole?: string,
        public  automaticQuotation?: boolean,
        public fromEffectiveDate?:string,
        public accessibility?:Accessibility,
        public reasonForApproval?:string,
        public captcha?:any,
        public oneTimePassword?:any,
        public isAccessPlatform: boolean = false,
        public policyEditPermission?: boolean,
        // public quickLinksPermissionDTOS = new QuickLinksPermissionDto(),
        public isAllowedAccouting?: boolean,
        // public quickLinksPermissions = new QuickLinksPermissionDto(),
        public enableSanctionScreening?:boolean,
        public finscanResultStatus?: string,
        public isAllowedForBulkDeclaration?: boolean,
        public entityType: TypeOfEntity = null,
        public website?: string,
        public policyHolderId?: string,
        public addressDTO?: IAddressMySuffix, // used in update
        public referredByBroker?: BrokerDTO,
        public referredByUnderwriter?: BrokerDTO,
        public referredByInsurer?: BrokerDTO,
        public address?: IAddressMySuffix, // used in view
        public policyCurrency?: string,
        public policyCurrencyValue?: number,
        public finScanResultData?: string,
        public isCoAssured?: boolean,
        public coAssuredInceptionDate?: string,
        public coAssuredExpiryDate?: string,
        public manager?: any
    ) {
        let dto = new ContactDetailDTO();
        this.contactDetails.push(dto);
        let bankInfo = new BankInfo();
        this.bankDetails.push(bankInfo);
        this.activeStatus = ActiveStatus.ACTIVE;
        this.addressDTO = new AddressMySuffix();
        this.referredByBroker = new BrokerDTO();
    }
}
